export default function MAXIFY_GX7092() {

    return <>
        <img src="https://image.kr.canon/re/product/2021061015331701_33640607.jpg" alt="GX6092 제품 특징 설명" width="98%" ></img>
        <img src="https://image.kr.canon/re/product/2022041813144801_12612600.jpg" alt="포스터아티스트 설명_1" width="98%"></img>
        <img src="https://image.kr.canon/re/product/2022041813151701_12607595.jpg" alt="포스터아티스트 설명_2" width="98%"></img>
    </>
}